export function megaMenu() {
  // const megaMenuColumns = document.querySelectorAll(".mega-menu-column");
  const megaMenuItems = document.querySelectorAll(".mega-menu-item");
  const previewImg = document.getElementById("mega-menu-preview");
  const placeholder = previewImg.dataset.placeholder;
  const megaMenuHeightEl = document.getElementById("mega-menu-height");

  if (!previewImg) return;

  if (megaMenuHeightEl) {
    previewImg.style.minHeight = megaMenuHeightEl.offsetHeight + "px";
    previewImg.style.minWidth = megaMenuHeightEl.offsetWidth + "px";
    previewImg.style.height = megaMenuHeightEl.offsetHeight + "px";
    previewImg.style.width = megaMenuHeightEl.offsetWidth + "px";
  }

  function changeImage(newSrc) {
    if (!newSrc || previewImg.src === newSrc) return;

    previewImg.style.opacity = "0";

    setTimeout(() => {
      previewImg.src = newSrc;
      previewImg.style.opacity = "1";
    }, 250);
  }

  // megaMenuColumns.forEach((column) => {
  //   column.addEventListener("mouseenter", function () {
  //     const thumbnailUrl = this.getAttribute("data-thumbnail");
  //     if (thumbnailUrl) {
  //       changeImage(thumbnailUrl);
  //     }
  //   });
  // });

  megaMenuItems.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      const thumbnailUrl = this.getAttribute("data-thumbnail");
      if (thumbnailUrl) {
        changeImage(thumbnailUrl);
      }
    });
  });

  const megaMenu = document.querySelector(".mega-menu");
  if (megaMenu) {
    megaMenu.addEventListener("mouseleave", function () {
      changeImage(placeholder);
    });
  }
}
